import React, { useEffect } from 'react';
import './index.scss';
import PageHeader from 'components/PageHeader';
import { getCreditHistory } from 'containers/Account/actions';
import { useStateValue } from 'context/app';
import { CURRENT_LANG_PREFIX } from 'constants/index';
import { useHistory } from 'react-router-dom';
import { removeStorage, getStorage } from 'utils/storage';
import { translate } from 'constants/language';
import FooterDesktop from 'components/FooterDesktop';
import ContainerDesktop from 'components/libs/ContainerDesktop';
import AccountWraper from 'containers/Account/views/AccountWraper';
import WalletIcon from 'assets/icons/account/wallet.svg';
import AccountTitle from 'containers/Account/views/AccountTitle';
import CreditView from './views/CreditView';

export default () => {
  const {
    account: [accountState, dispatch]
  } = useStateValue();

  const history = useHistory();
  const { config: { bankTransferCreditConfig = {} } = {} } = accountState;
 const goBack = async () => {
   const response = await getStorage('deleteNotEligible');
   if (response || response === 'true') {
     window.history.back();
   } else history.push(`/${CURRENT_LANG_PREFIX}/account`);
   await removeStorage('deleteNotEligible');
 };
  useEffect(() => {
    getCreditHistory({}, dispatch);
  }, []);

  return (
    <>
      <PageHeader
        showLogo={false}
        titleClassName="ml-10 mr-10"
        title={translate('My Credits')}
        backAction={goBack}
      />
      <ContainerDesktop isUserPage={true}>
        <AccountWraper>
          <AccountTitle
            title="My Credits"
            icon={<WalletIcon className="w-24" />}
            noBottomGap={true}
          />
          <CreditView
            creditHistory={accountState.creditHistory}
            returnableAmount={accountState.returnableAmount}
            bankTransferCreditConfig={bankTransferCreditConfig}
          />
        </AccountWraper>
      </ContainerDesktop>
      <FooterDesktop />
    </>
  );
};
